import request from '../../../shared/request'

export function getJobAttachments(job_id) {
  return request(`/job/attachments/${job_id}/`)
}

export function createAttachment(payload) {
  return request(`/job/attachments/${payload.job_id}/`, {
    method: 'POST',
    body: payload.file,
    headers: {
      Accept: 'application/json'
    }
  })
}

export function updateAttachment(payload) {
  return request(`/job/attachments/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/job/attachments/${payload.attachment_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/attachments.js